<div style="display: flex; flex-direction: column; height: 100%">
    <div style="display: flex; flex-direction: column; overflow: hidden; padding: 20px; height: auto; flex-grow: 1">
        <div style="justify-content: space-between; display: flex; margin: 15px">
            <div style="display: flex; gap: 20px">
                <kendo-label text="Start Date:">
                    <kendo-datepicker
                        [calendarType]="'classic'"
                        [clearButton]="true"
                        [size]="'large'"
                        [(value)]="startDate"
                        [format]="'dd-MM-yyyy'"
                        (valueChange)="onDateChange()"
                        [max]="today"
                    >
                    </kendo-datepicker>
                </kendo-label>
                <kendo-label text="End Date:">
                    <kendo-datepicker
                        [calendarType]="'classic'"
                        [clearButton]="true"
                        [size]="'large'"
                        [(value)]="endDate"
                        [format]="'dd-MM-yyyy'"
                        (valueChange)="onDateChange()"
                        [max]="today"
                    >
                    </kendo-datepicker>
                </kendo-label>
            </div>
            <div style="display: flex; gap: 20px">
                <button mat-raised-button color="primary" [disabled]="data.length === 0" (click)="grid.saveAsPDF()">
                    <mat-icon>download</mat-icon>
                    {{ "DAILYCHECKS.exportPdf" | translate }}
                </button>
                <button mat-raised-button color="primary" [disabled]="data.length === 0" (click)="grid.saveAsExcel()">
                    <mat-icon>download</mat-icon>
                    {{ "DAILYCHECKS.exportExcel" | translate }}
                </button>
            </div>
        </div>
        <div style="display: flex; flex-grow: 1; flex-direction: column; overflow: hidden; max-height: 100%; height: auto">
            <kendo-grid
                #grid="kendoGrid"
                [kendoGridBinding]="data"
                [data]="gridView"
                [sort]="state.sort"
                [scrollable]="'scrollable'"
                [sortable]="true"
                [filterable]="'menu'"
                [pageSize]="state.take"
                (dataStateChange)="dataStateChange($event)"
                (excelExport)="onExcelExport($event)"
                [pageable]="{
                    info: true,
                    type: 'numeric',
                    buttonCount: 8,
                    position: 'bottom',
                    previousNext: true,
                    pageSizes: pageSizes,
                }"
            >
                @for (col of gridData; track $index) {
                    <kendo-grid-column
                        field="{{ col.field }}"
                        title="{{ col.title | translate }}"
                        [headerStyle]="{ 'justify-content': 'center' }"
                        [style]="{ 'text-align': 'center' }"
                        [format]="col.format"
                    />
                }
                <kendo-grid-pdf
                    [fileName]="filename"
                    [allPages]="true"
                    paperSize="A4"
                    [scale]="0.7"
                    title="Daily Checks"
                    [margin]="'2cm'"
                    [subject]="aircraft.registrationMark"
                    [repeatHeaders]="true"
                >
                    <ng-template kendoGridPDFTemplate let-pageNum="pageNum" let-totalPages="totalPages">
                        <div class="page-template">
                            <div class="header">
                                <span>{{ aircraft.registrationMark }}</span>
                                <span>DAILY CHECKS</span>
                                <span>Period: {{ startDate | date: "dd/MM/yyyy" }} - {{ endDate | date: "dd/MM/yyyy" }}</span>
                            </div>
                            <div class="footer">{{ pageNum }}/{{ totalPages }}</div>
                        </div>
                    </ng-template>
                </kendo-grid-pdf>
                <kendo-grid-excel [fileName]="filename">
                    @let matPrimaryColor = "#4050b5";
                    @for (col of gridData; track $index) {
                        <kendo-excelexport-column
                            field="{{ col.field }}"
                            title="{{ col.title | translate }}"
                            [headerCellOptions]="{ background: matPrimaryColor }"
                            [cellOptions]="{ format: col.format, textAlign: 'left' }"
                        />
                    }
                </kendo-grid-excel>
            </kendo-grid>
        </div>
    </div>
</div>
